export default __webpack_public_path__ + "static/bluetooth_logo-2445409504f3f3ca4476d780e1dceda5.svg";